<template>
  <v-ons-page id="app">
    <v-ons-navigator :page-stack="pageStack">
    </v-ons-navigator>
    <!-- toast message normal
    <v-ons-toast :visible.sync="toastVisible" animation="ascend">
      <p class="toastMessage" v-html="toastMessage"></p>
      <button @click="setToastVisible(false)">ok</button>
    </v-ons-toast>
     -->
    <!-- toast message error
    <v-ons-toast :visible.sync="errorVisible" animation="ascend" class="toast_error">
      <p class="toastMessage" v-html="errorMessage"></p>
      <button @click="setErrorVisible(false)">ok</button>
    </v-ons-toast>
     -->

    

   <!--カートページ-->
    <v-ons-modal :visible="CartPageVisible" animation="lift">
      <ms-cartPage ref="CartPage" :cartData="CartItems"></ms-cartPage>
    </v-ons-modal>
  <!--メニューリストページ-->
   <v-ons-modal :visible="MenuListPageVisible" animation="lift">
      <ms-menuListPage ref="MenuListPage" :listData="WPMenuList"></ms-menuListPage>
    </v-ons-modal>

    <v-ons-dialog
      cancelable
      class="alert_dialog" :visible.sync="toastVisible" @click="setToastVisible(false)"
    >
    <div class="inner">
      <img class="alert_icon" src="./assets/img/ico_check.svg" alt="">
      <h4 class="alert_message" v-html="toastMessage"></h4>
    </div>
    </v-ons-dialog>

    <v-ons-dialog
      cancelable
      class="alert_dialog" :visible.sync="errorVisible" @click="setErrorVisible(false)"
    >
    <div class="inner">
      <img class="alert_icon" src="./assets/img/ico_alert.svg" alt="">
      <h4 class="alert_message error"  v-html="errorMessage"></h4>
    </div>
    </v-ons-dialog>

    <!-- loading screen -->
    <v-ons-modal :visible="isScreenLoading">
      <p style="text-align: center">
        <v-ons-icon size="40px" spin icon="md-spinner"></v-ons-icon>
      </p>
    </v-ons-modal>
    <v-ons-modal :visible="HistoryPageVisible" animation="lift">
      <ms-history></ms-history>
    </v-ons-modal>
  
  </v-ons-page>
</template>

<script>
import OrderHistoryPage from "./pages/OrderHistoryPage";
import CartPage from "./pages/CartPage";
import MenuListPage from "./pages/MenuListPage";

import { mapGetters, mapActions } from "vuex";
export default {
  name: 'App',
  data() {
    return {
      dialogVisible:true,
      timer:0,
    }
  },
  props:{
    shop_code: { type: String, default: '' },
    shop_ip: { type: String, default: '' },
    api_version: { type: String, default: '' },
    port_no: { type: String, default: '' },
    slip_no: { type: String, default: '' },
    slip_date: { type: String, default: '' },
    sesstion_flag: { type: String, default: '' },
  },
  created: function() {
    //this.setLanguage('1')
    const self=this
    this.initialize({
      shop_code: this.shop_code,
      shop_ip: this.shop_ip,
      api_version: this.api_version,
      port_no: this.port_no,
      slip_no: this.slip_no,
      slip_date: this.slip_date,
    }).then(()=>{
      
      self.getSettings()      //ローカルセッティング取得
      self.getWPAllPageList() //全メニューリスト取得

      console.log(JSON.stringify(
        {
            shop_code: self.shop_code,
            shop_ip: self.shop_ip,
            api_version: self.api_version,
            port_no: self.port_no,
            slip_no: self.slip_no,
            slip_date: self.slip_date,
          }
      ))
      //伝票取得定期実行
      self.timer=setInterval(
        ()=>{
          self.initialize({
            shop_code: self.shop_code,
            shop_ip: self.shop_ip,
            api_version: self.api_version,
            port_no: self.port_no,
            slip_no: self.slip_no,
            slip_date: self.slip_date,
          })
        },60000
      )
      if(self.token==''){
        //初めての時はスタートページへ
        self.navigatePage('start')
      }else{
        //２回目以降はトップメニューへ
        self.navigateWPPage('menu_top')
      }
      
    }).catch(error=>{
      //伝票照会失敗
      self.getSettings()
      self.navigatePage('notfound')
    })
    
  },
  computed: {
    ...mapGetters([
      'token',
      'pageStack',
      'isScreenLoading',
      'errorVisible',
      'toastVisible',
      'toastMessage',
      'errorMessage',
      'currentLang',
      'localizeLabel',
      'HistoryPageVisible',
      'CartItems',
      'CartPageVisible',
      'MenuListPageVisible',
      'WPMenuList',
      ]),
  },
  methods: {
    ...mapActions([
      'getSettings',
      'navigatePage',
      'navigateWPPage',
      'initialize',
      'setToastVisible',
      'setErrorVisible',
      'setLanguage',
      'SetCartPageVisible',
      'getWPAllPageList',
    ]),
   
  },
  components: {
    "ms-history":OrderHistoryPage,
    "ms-cartPage":CartPage,
    "ms-menuListPage":MenuListPage,
  }
}

</script>

<style  lang="scss" scoped>
@import "./assets/sass/base.scss";

</style>



// WEBPACK FOOTER //
// src/App.vue